/**
 * @module SocketDriver
 * @author Jonathan Casarrubias <t: johncasarrubias, gh: mean-expert-official>
 * @license MIT
 * @description
 * The SocketDriver class is used for dependency injection swapping.
 * It will be provided using factory method from different sources.
 **/
export class SocketDriver {
  connect(url: any, options: any) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/sockets/socket.driver.ts